export type Passenger = {
  passengerUUID?: string;
  clientBC: string;
  clientPassengerID: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  passengerFirstName?: string;
  passengerMiddleName?: string;
  passengerLastName?: string;
  dateOfBirth?: string;
  genderCode?: string;
  passengerAddresses: PassengerAddress[];
  passengerPhones: PassengerPhone[];
  passengerEmailAddress?: string;
  servicePlans: PassengerServicePlan[];
  sourceSystemBC?: string;
  source?: string;
  manual?: PassengerManualClient | PassengerManualInternal;
};

export type PassengerManualClient = {
  authorizationByClientFirstName: string;
  authorizationByClientLastName: string;
  passengerAuthorizationReasonBC: string;
};

export type PassengerManualInternal = {
  authorizationByUserID: string;
  reasonBC: string;
};

export type PassengerPhone = {
  hasSMSConsent: boolean;
  passengerPhoneUseBC: string;
  phoneNumberTypeBC: string;
  phoneNumber: string;
  phoneExtension?: string;
};

export type PassengerEmail = {
  isActive: boolean;
  isDeleted: boolean;
  passengerEmailUseBC: string;
  sourceSystemCode: string;
  emailTypeCode: string;
  emailAddress: string;
};

export type PassengerPreferredLanguage = {
  preferredLanguageCode: string;
  purposeOfUse: string;
};

export type PassengerAddress = {
  passengerAddressUseBC: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  stateCode?: string;
  zipCode?: string;
  label: string;
  placeID?: string;
};

export type PassengerServicePlan = {
  servicePlanUUID: string;
  effectiveStartDate?: string;
  // isDeleted: boolean;
  // eligibityStartDate: string;
  // eligibityEndDate?: string;
  // periodStartDateTime: string;
  // periodEndDateTime?: string;
  // altIdentifier?: PassengerAltIdentifier[];
};

export type PassengerAltIdentifier = {
  system: string;
  value: string;
};

export enum PassengerPreferenceBC {
  communication = 'COMMUNICATION',
  language = 'LANGUAGE',
  provider = 'PROVIDER',
  serviceLevel = 'SERVICE_LEVEL',
  vip = 'VIP',
}

export type PassengerPreference = {
  passengerProfileAttributeID?: number;
  passengerProfileAttributeTypeBC: string;
  attributeValue: string | null;
  passengerProfileAttributeUUID?: string;
  passengerCareLevelBC?: string;
};
